module.exports = __webpack_public_path__ + "img/166.restaurant_complex_cleaning.dc16d4c4.svg";